import { Component } from '@angular/core';
import { FieldWrapper } from "@ngx-formly/core";

@Component({
  selector: 'app-review-panel-section',
  templateUrl: './review-panel-section.component.html',
  styleUrls: ['./review-panel-section.component.scss']
})
export class ReviewPanelSectionComponent extends FieldWrapper {

}
